import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  updateStats: false,
  validateGamesStatsStatus: false,
  updateAccumulate: false,
  coefficientTrialCalculation: false,
  updateCoefficient: false,
  updateExternalResource: false,
};

const FormalGame = {
  updateStats: ({ seasonUniqid, gameUniqid, side, statsType, data }) => {
    if (debugStatus.updateStats) {
      return fakeApiHelper(200, 'success', {});
    }
    return ApiService.put(`/api/seasons/${seasonUniqid}/formal_games/${gameUniqid}/${statsType}/${side}`, {
      data,
    });
  },

  syncto: ({ seasonUniqid, gameUniqid, data, force, targets, partial }) => {
    return ApiService.put(
      `/api/seasons/${seasonUniqid}/sync_games/${gameUniqid}/to?force=${
        force ? 'true' : 'false'
      }&targets=${targets.join('&targets=')}&partial=${partial}`,
      { data },
    );
  },

  validateGamesStatsStatus: ({ seasonUniqid }) => {
    if (debugStatus.validateGamesStatsStatus) {
      return fakeApiHelper(200, 'success', {});
    }
    return ApiService.put(`/v2/api/seasons/${seasonUniqid}/formal_games_stats_status`);
  },

  updateAccumulate: ({ seasonUniqid }) => {
    return ApiService.put(`/v2/api/seasons/${seasonUniqid}/formal_stats_accumulate`);
  },

  coefficientTrialCalculation: ({ leagueUniqid, seasonUniqids, start, end, team }) => {
    return ApiService.get(
      `/v2/api/leagues/${leagueUniqid}/formal_stats_coefficient/trial_calculation` +
        `?seasons=${seasonUniqids.join('&seasons=')}` +
        `${start !== '' ? `&start=${start}` : ''}` +
        `${end !== '' ? `&end=${end}` : ''}` +
        `${team !== '' ? `&team=${team}` : ''}`,
      {
        timeout: 1000 * 60 * 5,
      },
    );
  },

  updateCoefficient: ({ leagueUniqid }) => {
    return ApiService.put(`/v2/api/leagues/${leagueUniqid}/formal_stats_coefficient`);
  },

  updateExternalResource: ({ leagueUniqid }) => {
    return ApiService.put(`/v2/api/leagues/${leagueUniqid}/formal_external_resource`);
  },
};

export default FormalGame;
